export default __webpack_public_path__ + "static/bt-8037950ff48148f1cd5d75a2a84aa48f.svg";